(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("rc-tree"));
	else if(typeof define === 'function' && define.amd)
		define("react-treeview", ["react", "rc-tree"], factory);
	else if(typeof exports === 'object')
		exports["react-treeview"] = factory(require("react"), require("rc-tree"));
	else
		root["react-treeview"] = factory(root["React"], root["Tree"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_10__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition